import { useEffect } from "react";
import { Table, Tooltip, Fab, TableContainer, TableRow, TextField, IconButton, Select, InputLabel, FormControl, Paper } from '@mui/material';
import { Plus, Trash2, Pencil, Save } from 'lucide-react';
import './TableStyle.css';
import { makeStyles } from "@material-ui/core/styles";

function TableModifyList(props) {
    const classes = useStyles();
    var today = new Date();

    useEffect(() => {
        // eslint-disable-next-line 
    }, [props.Login.userid])

    const setItemName = (event, id) => {
        let tempArray = [...props.rows]
        if (tempArray.find(x => x.Id === id) !== undefined) {
            tempArray.find(x => x.Id === id).itemName = event.target.value
        } else {
            tempArray.find(x => x.edit === true).itemName = event.target.value;
        }
        props.setRows(tempArray)
    }

    const setItemDescription = (event, id) => {
        let tempArray = [...props.rows]
        if (tempArray.find(x => x.Id === id) !== undefined) {
            tempArray.find(x => x.Id === id).itemDescription = event.target.value
        } else {
            tempArray.find(x => x.edit === true).itemDescription = event.target.value;
        }
        props.setRows(tempArray)
    }

    const GenerateId = () => {
        let tempArray = [...props.rows];
        const ids = tempArray.map(object => {
            return object.Id;
        });

        const max = Math.max(...ids);

        if (tempArray.length === 0) {
            return 1;
        }
        else {
            let index = max;
            index++;
            return index;
        }
    }

    const editListItem = (id) => {
        let tempArray = [...props.rows];
        tempArray.find(x => x.Id === id).edit = true;
        props.setRows(tempArray);
    }

    const saveListItem = (id) => {
        let tempArray = [...props.rows];
        if (tempArray.find(x => x.Id === id).itemName !== "" || tempArray.find(x => x.Id === id).itemName !== null) {
            tempArray.find(x => x.Id === id).edit = false;
            props.setRows(tempArray);
        }
    }

    const deleteListItem = (id) => {
        let tempArray = [...props.rows];
        let index = tempArray.indexOf(tempArray.find(x => x.Id === id));
        tempArray.splice(index, 1);
        props.setRows(tempArray);
    }

    const addRow = () => {
        let userid = props.Login.userid;
        let Rowid = { Id: GenerateId(), itemDescription: "", edit: true, itemName: "", UserId: props.Login.userid, InsertedOn: today, InsertedByUserId: userid, state: "new" }
        let PrevId = GenerateId() - 1;
        var tempArray = [...props.rows];
        if (tempArray.find(x => x.itemName === "") === undefined) {
            if (tempArray.length !== 0) {
                if (tempArray.find(x => x.Id === PrevId).itemDescription !== "") {
                    tempArray.find(x => x.Id === PrevId).edit = false;
                    tempArray.push(Rowid);
                    props.setRows(tempArray);
                }
                else {
                    tempArray.push(Rowid);
                    props.setRows(tempArray);
                }
            }
            else {
                tempArray.push(Rowid);
                props.setRows(tempArray);
            }
        }
    }

    return (
        <TableContainer style={{ borderTopRightRadius: "8px", borderTopLeftRadius: "8px" }} component={Paper}>
            <Table>
                <thead className={classes.tableHead}>
                    <tr>
                        <th align="center">#</th>
                        <th width="30%">Name</th>
                        <th width="60%">Description</th>
                        <th width="10%" colSpan={2} align="center" >Actions</th>
                    </tr>
                </thead>
                <tbody align="center" className={classes.tableContent}>
                    {
                        props.rows.map((x, index) =>
                            <TableRow key={x.Id} className={classes.tableRow}>
                                <td className={classes.indexTd} >
                                    <div className={classes.listOrder}>
                                        {index + 1}
                                    </div>
                                </td>
                                <td className={classes.tableTd}>
                                    {x.edit ?// eslint-disable-next-line
                                        <TextField label={x.itemName ? " " : "Name"} InputLabelProps={{ shrink: false }} style={{ width: '100%' }} className={classes.descriptionField} id="outlined-basic" type={"search"} variant="outlined" value={x.itemName === undefined ? '' : x.itemName.length > 0 ? x.itemName : ''} onChange={(event) => setItemName(event, x.Id)} /> :
                                        <TextField style={{ width: '100%' }} disabled value={x.itemName} />
                                    }
                                </td>
                                <td className={classes.tableTd}>
                                    {x.edit ?// eslint-disable-next-line
                                        <TextField label={x.itemDescription ? " " : "Description"} style={{ width: '100%' }} className={classes.descriptionField} id="outlined-basic" type={"search"} variant="outlined" value={x.itemDescription === undefined ? '' : x.itemDescription.length > 0 ? x.itemDescription : ''} onChange={(event) => setItemDescription(event, x.Id)} /> :
                                        <TextField style={{ width: '100%' }} disabled value={x.itemDescription} />
                                    }
                                </td>
                                <td className={classes.tableTd} align="center">
                                    {x.edit ?
                                        // <Tooltip title="Save" placement="top" disableInteractive arrow>
                                        <IconButton aria-label="save" style={{ borderRadius: 0 }} onClick={() => saveListItem(x.Id)} className={classes.editButton} size="large">
                                            <Save fontSize="inherit" />
                                        </IconButton>
                                        // </Tooltip>
                                        :
                                        // <Tooltip title="Edit" placement="top" disableInteractive arrow>
                                        <IconButton aria-label="edit" style={{ borderRadius: 0 }} onClick={() => editListItem(x.Id)} className={classes.editButton} size="large">
                                            <Pencil fontSize="inherit" />
                                        </IconButton>
                                        // </Tooltip>
                                    }
                                    {/* <Tooltip title="Delete" placement="top" disableInteractive arrow>
                                        <IconButton style={{ borderRadius: 0 }} className={classes.deleteButton} onClick={() => deleteListItem(x.Id)}>
                                            <Trash2 />
                                        </IconButton>
                                    </Tooltip> */}
                                </td>
                                <td>
                                    <IconButton aria-label="delete" onClick={() => deleteListItem(x.Id)} className={classes.functionButton} color='error' size="large">
                                        <Trash2 fontSize="inherit" />
                                    </IconButton>

                                </td>
                            </TableRow>
                        )
                    }
                    <TableRow className={classes.addRow} onClick={addRow}>
                        <td className={classes.indexTd}>
                            -
                        </td>
                        <td className={classes.tableTd}>
                            <FormControl fullWidth>
                                <InputLabel>Name</InputLabel>
                                <Select
                                    IconComponent={() => (null
                                    )} disabled />
                            </FormControl>
                        </td>
                        <td className={classes.tableTd}>
                            <FormControl fullWidth>
                                <InputLabel>Description</InputLabel>
                                <Select
                                    IconComponent={() => (null
                                    )} disabled />
                            </FormControl>
                        </td>
                        <td className={classes.tableTd} colSpan="2" align="center">
                            <Fab size="medium">
                                <Plus />
                            </Fab>
                        </td>
                    </TableRow>
                </tbody>
            </Table >
        </TableContainer >
    )
}

export default TableModifyList;

const useStyles = makeStyles({
    tableContent: {
        paddingTop: "15px",
    },
    tableRow: {
        height: '60px',
    },
    tableHead: {
        backgroundColor: "#e0dce4",
        marginBottom: "15px",
    },
    descriptionField: {
        width: "100%",
    },

    editButton: {
        fontSize: '2rem !important',
        color: '#0B4097 !important',
    },

    functionButton: {
        fontSize: '2rem !important',

    },
    addRow: {
        opacity: "0.3"
    },
    tableTd: {
        padding: "-5px",
    },
    indexTd: {
        borderRight: '2px solid rgb(224, 224, 224)',
        width: '25px',
        background: 'rgba(0, 0, 0, 0.54)',
        color: 'white',
        zIndex: '2',
    },
    emptydrag: {
        padding: '17px !important',
        border: '0'
    },
    listOrder: {
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    dragTd: {
        border: '0',
        width: '24px',
    },
    dragIcon: {
        float: 'left',
    },
});